import { briefAPI } from '../baseApi';

export async function getBriefAPI(lang) {
    let url = 'select_video_rising?';

    try {
        let result =  await briefAPI.get(`${url}limit=8&language=${lang}`)
        return result
    }catch(err){
        console.log('brief get error', err.response?.data || err);
        throw err;
    }
}
